export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قيد التنفيذ"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مكتمل"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قيد الانتظار"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["التالي"])}
}